export default __webpack_public_path__ + "static/laptop_with_ems-7395fb39232854f77fbf7186c9cac0ca.png";